import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useDebounce } from "use-debounce";
import { getDiaryDataBySearch } from "../../../api/diary-service";

const DEBOUNCE_DELAY = 500;
const MIN_QUERY_LENGTH = 3;
const STALE_TIME = 1000 * 60; // 1 minute
const DEFAULT_DATABASES = { db1: true, db2: true };

const useDiarySearch = (rawQuery, databases = DEFAULT_DATABASES) => {
	const queryClient = useQueryClient();

	const safeQuery = typeof rawQuery === "string" ? rawQuery : "";

	// DEBOUNCE QUERY
	const [debouncedQuery] = useDebounce(safeQuery, DEBOUNCE_DELAY);

	const enabled = debouncedQuery.length >= MIN_QUERY_LENGTH;

	// QUERY KEY
	const queryKey = ["search", debouncedQuery, databases.db1, databases.db2];

	const { data, isLoading, isFetching, isError, error } = useQuery({
		queryKey,
		queryFn: ({ signal }) =>
			getDiaryDataBySearch(
				{
					query: debouncedQuery,
					db1: databases.db1,
					db2: databases.db2,
				},
				signal,
			),
		enabled,
		staleTime: STALE_TIME,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	});

	// MANUAL REFRESH
	const refresh = () => queryClient.invalidateQueries(queryKey);

	return {
		data,
		isLoading,
		isFetching,
		isError,
		error,
		enabled,
		debouncedQuery,
		refresh,
	};
};

export default useDiarySearch;
